import client from './client';

/** Row shape from sp_GetFamilySubscriptionYear (12 month amount/date/status columns) */
export interface SubscriptionYear {
  family_id?:         number;
  subscription_year?: number;
  [key: string]: unknown; // jan_amount, jan_paid_date, jan_status, feb_amount, ...
}

export interface LastPaidSubscription {
  paid_date?:         string | null;
  amount?:            number;
  status?:            string;
  subscription_year?: number;
}

export interface SubscriptionMonthPayload {
  amount:   number;
  paidDate: string | null;
  status:   'Paid' | 'Unpaid';
}

export const getFamilySubscriptionYear = async (
  familyId: number, year: number,
): Promise<SubscriptionYear> => {
  const { data } = await client.get<{ data: SubscriptionYear }>(
    `/family/${familyId}/subscriptions/${year}`,
  );
  return data.data;
};

export const setFamilySubscriptionMonth = async (
  familyId: number, year: number, month: number, payload: SubscriptionMonthPayload,
): Promise<SubscriptionYear> => {
  const { data } = await client.put<{ data: SubscriptionYear }>(
    `/family/${familyId}/subscriptions/${year}/${month}`, payload,
  );
  return data.data;
};

export const deleteSubscriptionMonth = async (
  familyId: number, year: number, month: number,
): Promise<SubscriptionYear> => {
  const { data } = await client.delete<{ data: SubscriptionYear }>(
    `/family/${familyId}/subscriptions/${year}/${month}`,
  );
  return data.data;
};

export const getLastPaidSubscription = async (
  familyId: number,
): Promise<LastPaidSubscription | null> => {
  const { data } = await client.get<{ data: LastPaidSubscription | null }>(
    `/family/${familyId}/subscriptions/last-paid`,
  );
  return data.data;
};

// ── Subscription matrix (all families × monthly status) ───────────────────────

export interface SubscriptionMatrixRow {
  familyId:      number;
  familyCode:    string;
  familyHead:    string;
  anbiyamName:   string;
  monthlyAmount: number;
  jan_status:    string | null;
  feb_status:    string | null;
  mar_status:    string | null;
  apr_status:    string | null;
  may_status:    string | null;
  jun_status:    string | null;
  jul_status:    string | null;
  aug_status:    string | null;
  sep_status:    string | null;
  oct_status:    string | null;
  nov_status:    string | null;
  dec_status:    string | null;
  paidCount:     number;
}

export interface SubscriptionMatrixParams {
  year:        number;
  anbiyam?:    number | null;
  search?:     string;
  memberName?: string;
  familyId?:   number | null;
  page?:       number;
  pageSize?:   number;
}

export interface SubscriptionMatrixResult {
  items:      SubscriptionMatrixRow[];
  total:      number;
  totalPages: number;
  page:       number;
}

export const getSubscriptionMatrix = async (
  params: SubscriptionMatrixParams,
): Promise<SubscriptionMatrixResult> => {
  const p: Record<string, string> = { year: String(params.year) };
  if (params.anbiyam)     p.anbiyam    = String(params.anbiyam);
  if (params.search)      p.search     = params.search;
  if (params.memberName)  p.memberName = params.memberName;
  if (params.familyId)    p.familyId   = String(params.familyId);
  if (params.page)    p.page     = String(params.page);
  if (params.pageSize) p.pageSize = String(params.pageSize);
  const { data } = await client.get<{ data: SubscriptionMatrixResult }>('/subscriptions/matrix', { params: p });
  return data.data;
};
